import { render, staticRenderFns } from "./CommunityQnaCreate.vue?vue&type=template&id=47616454&"
import script from "./CommunityQnaCreate.vue?vue&type=script&lang=js&"
export * from "./CommunityQnaCreate.vue?vue&type=script&lang=js&"
import style0 from "./CommunityQnaCreate.vue?vue&type=style&index=0&id=47616454&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports